export const blogDescription = `Read articles about app development from Lunka Tech company’s experts.✔`;
export const worksDescription = `See works about app development from Lunka Tech company’s experts.✔`;
export const aboutUsDescription = `See our Lunka Tech developers team.✔`;
export const contactUsDescription = `Contact Lunka Tech.✔`;
export const supportUkraineDescription = `Support Ukraine with Lunka.✔`;
